// extracted by mini-css-extract-plugin
module.exports = {"Box":"ColorSearch_Box__AfkEL","SearchbarContainer":"ColorSearch_SearchbarContainer__30Eey","Searchbar":"ColorSearch_Searchbar__1DDom","Dropdown":"ColorSearch_Dropdown__1gEDm"};